import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faSave,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { Modal } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import {
  periodOneMileStoneNames,
  periodOtherMilestoneNames,
  periodOneLandlordMileStoneNames,
} from "../../constants";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import { leaseDateFormat } from "../../utils/utils";
import { hasAccess, getUserType } from "../../utils/index";

var periodOneMileStoneNamesArr = periodOneMileStoneNames;

if (getUserType() == "Landlord") {
  periodOneMileStoneNamesArr = periodOneLandlordMileStoneNames;
}

class RentDepositDetails extends React.Component {
  countError = "";
  state = {
    milestoneVal: "",
    readOnEdit: false,
    currentIndex: null,
    disableOnEdit: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    index_val: "",
    delete: false,
    keyvalue: "",
    leaseCommencementDate: "",
    popupData: {},
    isOpen: false,
    milestoneMonths: "RDEP Milestone # Months",
    rdepTotalAmount: "",
    showForm: true,
    fromDate: "",
    toDate: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    period: 1,
    redirect: false,
    milestonesCount: 1,
    milestones: [],
    milestoneNamesValues: [],
    initialValues: {
      rdepLogic: {
        milestones: [],
        period: "",
        rentDepositNature: "",
        months: "",
        fromDate: "",
        toDate: "",
        rateUOM: "",
        onArea: "",
        milestonesCount: 0,
        totalAmount: "",
        rate: "",
      },
    },
    biFurcateLandlordCheckbox: false,
    rentDepositDetails: [],
    landlordList: [],
    landlordsPercentage: [],
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {

    let athis = this;
    axios({
      url:`${apiUrl.apiUrl.url}/create-lease/fetch-lease-rent-deposit-details?id=${this.props.match.params.id}`,
      method: 'GET',
    }).then(function (response){
      let data = response.data;
      athis.state.biFurcateLandlordCheckbox = data.biFurcateLandlordCheckbox;
        athis.state.leaseCommencementDate = data.lcd;
        athis.state.landlordList = data.landlordList;
        athis.state.fromDate = data.from;
        athis.state.renewalLeaseTermYY = data.renewalLeaseTermYY;
        athis.state.renewalLeaseTermDD = data.renewalLeaseTermDD;
        athis.state.renewalLeaseTermMM = data.renewalLeaseTermMM;

        if (data.rentDepositDetails.length > 0) {
          // let _tempDate = new Date(
          //   data.rentDepositDetails[data.rentDepositDetails.length - 1].toDate
          // );
          // _tempDate.setDate(_tempDate.getDate() + 1);
          // var dd = ("0" + _tempDate.getDate()).slice(-2);
          // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
          // var y = _tempDate.getFullYear();
          // var someFormattedDate = y + "-" + mm + "-" + dd;
          // athis.state.fromDate = someFormattedDate;
          athis.setState({
            fromDate: getToDate(
              data.rentDepositDetails[data.rentDepositDetails.length - 1]
                .toDate,
              2,
              0,
              0
            ),
          });
        }

        athis.setState({
          initialValues: data,
          rentDepositDetails: data.rentDepositDetails,
          leaseTermDD: data.leaseTermDD,
          leaseTermMM: data.leaseTermMM,
          leaseTermYY: data.leaseTermYY,
          // notes_11: data.notes_11,
          period:
            data.rentDepositDetails.length > 0
              ? data.rentDepositDetails.length + 1
              : 1,
        });
        var _intialValues = athis.state.initialValues;
        // _intialValues['notes_11'] = data.notes_11;
        _intialValues.rdepLogic = {
          milestones: [
            {
              dueDate: "",
              milestoneName: "",
              amount: "",
              milestonePercent: "",
            },
          ],
          period: "",
          rentDepositNature: "",
          months: "",
          fromDate: "",
          toDate: "",
          rateUOM: "",
          onArea: "",
          milestonesCount: 0,
          totalAmount: "",
          rate: "",
        };
        athis.setState({
          initialValues: _intialValues,
        });
        if (
          data.rentDepositDetails[data.rentDepositDetails.length - 1].toDate ==
          data.to
        ) {
          athis.setState({
            showForm: false,
          });
        }
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-rent-deposit-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.biFurcateLandlordCheckbox = data.biFurcateLandlordCheckbox;
    //     this.state.leaseCommencementDate = data.lcd;
    //     this.state.landlordList = data.landlordList;
    //     this.state.fromDate = data.from;
    //     this.state.renewalLeaseTermYY = data.renewalLeaseTermYY;
    //     this.state.renewalLeaseTermDD = data.renewalLeaseTermDD;
    //     this.state.renewalLeaseTermMM = data.renewalLeaseTermMM;

    //     if (data.rentDepositDetails.length > 0) {
    //       // let _tempDate = new Date(
    //       //   data.rentDepositDetails[data.rentDepositDetails.length - 1].toDate
    //       // );
    //       // _tempDate.setDate(_tempDate.getDate() + 1);
    //       // var dd = ("0" + _tempDate.getDate()).slice(-2);
    //       // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
    //       // var y = _tempDate.getFullYear();
    //       // var someFormattedDate = y + "-" + mm + "-" + dd;
    //       // this.state.fromDate = someFormattedDate;
    //       this.setState({
    //         fromDate: getToDate(
    //           data.rentDepositDetails[data.rentDepositDetails.length - 1]
    //             .toDate,
    //           2,
    //           0,
    //           0
    //         ),
    //       });
    //     }

    //     this.setState({
    //       initialValues: data,
    //       rentDepositDetails: data.rentDepositDetails,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       // notes_11: data.notes_11,
    //       period:
    //         data.rentDepositDetails.length > 0
    //           ? data.rentDepositDetails.length + 1
    //           : 1,
    //     });
    //     var _intialValues = this.state.initialValues;
    //     // _intialValues['notes_11'] = data.notes_11;
    //     _intialValues.rdepLogic = {
    //       milestones: [
    //         {
    //           dueDate: "",
    //           milestoneName: "",
    //           amount: "",
    //           milestonePercent: "",
    //         },
    //       ],
    //       period: "",
    //       rentDepositNature: "",
    //       months: "",
    //       fromDate: "",
    //       toDate: "",
    //       rateUOM: "",
    //       onArea: "",
    //       milestonesCount: 0,
    //       totalAmount: "",
    //       rate: "",
    //     };
    //     this.setState({
    //       initialValues: _intialValues,
    //     });
    //     if (
    //       data.rentDepositDetails[data.rentDepositDetails.length - 1].toDate ==
    //       data.to
    //     ) {
    //       this.setState({
    //         showForm: false,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  calculateToDate() {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        this.state.periodTermMM,
        this.state.periodTermYY
      ),
    });
  }

  getDepositNature(e, values, setFieldValue) {
    if (
      this.state.rentDepositDetails[e.target.value] !== undefined &&
      this.state.rentDepositDetails[e.target.value].length > 0 &&
      this.state.rentDepositDetails[e.target.value][
        this.state.rentDepositDetails[e.target.value].length - 1
      ].toDate == values.to
    ) {
      setFieldValue("rdepLogic.rentDepositNature", "");
      this.setState({
        popupalertMessage: true,
        popupMessageContent: "Values For this type has completed the period",
      });
      return false;
    }
    var _rentDepositDetails = this.state.rentDepositDetails;
    if (
      _rentDepositDetails[e.target.value] == undefined ||
      _rentDepositDetails[e.target.value].length == 0
    ) {
      this.state.fromDate = values.from;
      this.state.toDate = "";
      this.state.period = 1;
    } else {
      this.state.fromDate = getToDate(
        _rentDepositDetails[e.target.value][
          _rentDepositDetails[e.target.value].length - 1
        ].toDate,
        2,
        0,
        0
      );
      this.state.toDate = "";
      this.state.period =
        this.state.rentDepositDetails[e.target.value].length + 1;
    }
    this.setState({});
    if (this.state.period == "1") {
      this.setState({
        milestoneNamesValues: periodOneMileStoneNamesArr,
      });
    } else {
      this.setState({
        milestoneNamesValues: periodOtherMilestoneNames,
      });

      // periodOtherMilestoneNames = [];
      // periodOtherMilestoneNames.push(
      //   periodOtherMilestoneNames[
      //     this.state.rentDepositDetails[e.target.value][
      //       this.state.rentDepositDetails[e.target.value].length - 1
      //     ].milestones.length - 1
      //   ]
      // );
      // this.setState({
      //   milestoneNamesValues: periodOtherMilestoneNames.length
      //     ? []
      //     : periodOtherMilestoneNames[
      //         this.state.rentDepositDetails[e.target.value][
      //           this.state.rentDepositDetails[e.target.value].length - 1
      //         ].milestones.length - 1
      //       ],
      // });

      // this.state.milestoneVal =
      //   `Escalation ` +
      //   this.state.rentDepositDetails[e.target.value][
      //     this.state.rentDepositDetails[e.target.value].length - 1
      //   ].period;

      // this.setState({});
    }
    return true;
  }

  editRd(index, values, key) {
    this.state.currentIndex = index;
    this.state.disableOnEdit = false;
    this.state.readOnEdit = true;
    this.state.period = this.state.rentDepositDetails[key][index].period;
    if (this.state.rentDepositDetails[key][index].period == "1") {
      this.setState({
        milestoneNamesValues: periodOneMileStoneNamesArr,
      });
    } else {
      this.setState({
        milestoneNamesValues: periodOtherMilestoneNames,
      });
    }
    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.rentDepositDetails[key][index].periodTermDD,
      periodTermMM: this.state.rentDepositDetails[key][index].periodTermMM,
      periodTermYY: this.state.rentDepositDetails[key][index].periodTermYY,
    });
    this.state.milestonesCount =
      this.state.rentDepositDetails[key][index].milestones.length;
    this.state.fromDate = this.state.rentDepositDetails[key][index].fromDate;
    this.state.toDate = this.state.rentDepositDetails[key][index].toDate;
    values.rdepLogic.rentDepositNature =
      this.state.rentDepositDetails[key][index].rentDepositNature;
    values.rdepLogic.months = this.state.rentDepositDetails[key][index].months;
    values.rdepLogic.rateUOM =
      this.state.rentDepositDetails[key][index].rateUOM;
    values.rdepLogic.rate = this.state.rentDepositDetails[key][index].rate;
    values.rdepLogic.totalAmount =
      this.state.rentDepositDetails[key][index].totalAmount;

    for (
      let i = 0;
      i < this.state.rentDepositDetails[key][index].milestones.length;
      i++
    ) {
      // if (this.state.milestones === undefined) {
      this.state.milestones[i] = {};
      values.rdepLogic.milestones[i] = {};
      this.state.milestones[i].milestoneName =
        this.state.rentDepositDetails[key][index].milestones[i].milestoneName;
      values.rdepLogic.milestones[i].milestoneName =
        this.state.rentDepositDetails[key][index].milestones[i].milestoneName;
      this.state.milestones[i].dueDate =
        this.state.rentDepositDetails[key][index].milestones[i].dueDate;
      values.rdepLogic.milestones[i].dueDate =
        this.state.rentDepositDetails[key][index].milestones[i].dueDate;
      this.state.milestones[i].milestonePercent =
        this.state.rentDepositDetails[key][index].milestones[
          i
        ].milestonePercent;
      values.rdepLogic.milestones[i].milestonePercent =
        this.state.rentDepositDetails[key][index].milestones[
          i
        ].milestonePercent;
      this.state.milestones[i].amount =
        this.state.rentDepositDetails[key][index].milestones[i].amount;
      values.rdepLogic.milestones[i].amount =
        this.state.rentDepositDetails[key][index].milestones[i].amount;
      if (
        this.state.rentDepositDetails[key][index].milestones[i].milestoneType !=
        undefined
      ) {
        this.state.milestones[i].milestoneType =
          this.state.rentDepositDetails[key][index].milestones[i].milestoneType;
        values.rdepLogic.milestones[i].milestoneType =
          this.state.rentDepositDetails[key][index].milestones[i].milestoneType;
      }
      if (
        this.state.rentDepositDetails[key][index].milestones[
          i
        ].milestoneName.includes("Escalation")
      ) {
        this.state.milestones[i].milestoneQuantityType = "RDEP Milestone %";
        values.rdepLogic.milestones[i].milestoneQuantityType =
          "RDEP Milestone %";
      } else {
        this.state.milestones[i].milestoneQuantityType =
          "RDEP Milestone # Months";
        values.rdepLogic.milestones[i].milestoneQuantityType =
          "RDEP Milestone # Months";
      }
      this.setState({});
      // }
    }

    this.setState({});
  }

  addDetails = (values, resetForm) => {
    console.log(values.rdepLogic);
    if (this.state.currentIndex === null) {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }
      if (this.state.biFurcateLandlordCheckbox === true) {
        let count = 0;
        for (let i = 0; i < this.state.landlordList.length; i++) {
          count += Number(this.state.landlordList[i].percent);
        }
        if (count < 100) {
          this.setState({
            popupalertMessage: true,
            popupMessageContent: "Total landlord percentage should be 100",
          });
          return false;
        }
      }
      var totalMilestoneAmount = 0;
      for (let i = 0; i < values.rdepLogic.milestones.length; i++) {
        totalMilestoneAmount += Number(this.state.milestones[i].amount);
      }

      if (this.state.period == "1") {
        if (totalMilestoneAmount != values.rdepLogic.totalAmount) {
          // alert(
          //   "Total Amount of Milestones do not match with total amount of period"
          // );
          this.setState({
            popupalertMessage: true,
            popupMessageContent:
              "Total Amount of Milestones do not match with total amount of period",
          });
          return false;
        }
      } else {
        var previousAmount =
          this.state.rentDepositDetails[values.rdepLogic.rentDepositNature][
            this.state.rentDepositDetails[values.rdepLogic.rentDepositNature]
              .length - 1
          ].totalAmount;
        var currentAmount = values.rdepLogic.totalAmount;
        var balanceAmount = currentAmount - previousAmount;
        for (let i = 0; i < values.rdepLogic.milestones.length; i++) {
          if (this.state.period > 1) {
            values.rdepLogic.milestones[i].milestoneType = "RDEP Percent";
            this.setState({});
          }
        }
      }
      // this.state.milestoneVal = `Escalation ` + values.rdepLogic.period;

      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        // alert("Enter a date less than " + values.to);
        return false;
      }
      var _rentDepositDetails = this.state.rentDepositDetails;
      values.rdepLogic.period = this.state.period;
      values.rdepLogic.fromDate = this.state.fromDate;
      values.rdepLogic.toDate = this.state.toDate;
      values.rdepLogic.periodTermYY = this.state.periodTermYY;
      values.rdepLogic.periodTermMM = this.state.periodTermMM;
      values.rdepLogic.periodTermDD = this.state.periodTermDD;
      // for (let i = 0; i < this.state.landlordList; i++) {

      // }
      if (
        _rentDepositDetails[values.rdepLogic.rentDepositNature] == undefined
      ) {
        _rentDepositDetails[values.rdepLogic.rentDepositNature] = [];
      }
      _rentDepositDetails[values.rdepLogic.rentDepositNature].push({
        ...values.rdepLogic,
      });

      this.setState({
        rentDepositDetails: _rentDepositDetails,
      });
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      values.rdepLogic.totalAmount = "";
      this.state.milestonesCount = 1;
      this.state.milestones = [];
      values.rdepLogic.milestones = [];
      this.state.period++;
      values.rdepLogic.rate = "";
      values.rdepLogic.escalationPercent = '';
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.period == "1") {
        this.setState({
          milestoneNamesValues: periodOneMileStoneNamesArr,
        });
      } else {
        this.setState({
          milestoneNamesValues: periodOtherMilestoneNames,
        });
      }

      // this.state.milestonesCount = 1;
      // resetForm();
      this.validator.hideMessages();
      // this.state.milestones = [];
    } else {
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      var totalMilestoneAmount = 0;
      for (let i = 0; i < values.rdepLogic.milestones.length; i++) {
        totalMilestoneAmount += Number(this.state.milestones[i].amount);
        console.log(this.state.milestones[i].amount);
      }
      if (this.state.period == "1") {
        if (totalMilestoneAmount != values.rdepLogic.totalAmount) {
          this.setState({
            popupalertMessage: true,
            popupMessageContent:
              "Total Amount of Milestones do not match with total amount of period",
          });
          return false;
        }
      } else {
        var previousAmount =
          this.state.rentDepositDetails[values.rdepLogic.rentDepositNature][
            this.state.rentDepositDetails[values.rdepLogic.rentDepositNature]
              .length - 1
          ].totalAmount;
        var currentAmount = values.rdepLogic.totalAmount;
        var balanceAmount = currentAmount - previousAmount;

        for (let i = 0; i < values.rdepLogic.milestones.length; i++) {
          if (this.state.period > 1) {
            values.rdepLogic.milestones[i].milestoneType = "CDEP Percent";
            this.setState({});
          }
        }
      }

      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        return false;
      }
      var _rentDepositDetails = this.state.rentDepositDetails;
      values.rdepLogic.period = this.state.period;
      values.rdepLogic.fromDate = this.state.fromDate;
      values.rdepLogic.toDate = this.state.toDate;
      values.rdepLogic.periodTermYY = this.state.periodTermYY;
      values.rdepLogic.periodTermMM = this.state.periodTermMM;
      values.rdepLogic.periodTermDD = this.state.periodTermDD;

      if (
        _rentDepositDetails[values.rdepLogic.rentDepositNature] == undefined
      ) {
        _rentDepositDetails[values.rdepLogic.rentDepositNature] = [];
      }
      _rentDepositDetails[values.rdepLogic.rentDepositNature][
        this.state.currentIndex
      ] = { ...values.rdepLogic };

      _rentDepositDetails[values.rdepLogic.rentDepositNature][
        this.state.currentIndex
      ].milestones = this.state.milestones;
      this.setState({
        rentDepositDetails: _rentDepositDetails,
      });

      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      // this.state.fromDate = "";
      // this.state.toDate = "";
      this.state.period++;
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      // this.state.milestonesCount = 1;
      // resetForm();
      this.validator.hideMessages();
      // this.state.milestones = [];
      // values.rdepLogic.rentDepositNature = "";
      this.state.disableOnEdit = false;
      this.state.currentIndex = null;
      this.state.readOnEdit = false;
      this.setState({});
    }
  };

  resetDetails = (values, resetForm) => {
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;
    this.state.fromDate = "";
    this.state.toDate = "";
    this.state.period = "";
    this.state.milestonesCount = 1;
    resetForm();
    this.validator.hideMessages();
    this.state.milestones = [];
    values.rdepLogic.rentDepositNature = "";
    this.state.disableOnEdit = false;
    this.state.currentIndex = null;
    this.state.readOnEdit = false;
    this.setState({});
  };

  calculateRdepAmount(values, setFieldValue) {
    if (values.rdepLogic.rateUOM == "Flat Amount") {
      values.rdepLogic.totalAmount =
        Number(values.rdepLogic.rate) * Number(values.rdepLogic.months);
      setFieldValue(
        "rdepLogic.totalAmount",
        Number(values.rdepLogic.rate) * Number(values.rdepLogic.months)
      );
    } else if (
      values.rdepLogic.rateUOM == "Per Sq Ft" &&
      values.rdepLogic.onArea == "Carpet Area"
    ) {
      values.rdepLogic.totalAmount =
        Number(values.rdepLogic.rate) *
        Number(values.totalCarpetArea) *
        Number(values.rdepLogic.months);
      setFieldValue(
        "rdepLogic.totalAmount",
        Number(values.rdepLogic.rate) *
        Number(values.totalCarpetArea) *
        Number(values.rdepLogic.months)
      );
    } else if (
      values.rdepLogic.rateUOM == "Per Sq Ft" &&
      values.rdepLogic.onArea == "Usable Area"
    ) {
      values.rdepLogic.totalAmount =
        Number(values.rdepLogic.rate) *
        Number(values.totalUsableArea) *
        Number(values.rdepLogic.months);
      setFieldValue(
        "rdepLogic.totalAmount",
        Number(values.rdepLogic.rate) *
        Number(values.totalUsableArea) *
        Number(values.rdepLogic.months)
      );
    } else if (
      values.rdepLogic.rateUOM == "Per Sq Ft" &&
      values.rdepLogic.onArea == "Gross Leasable Area"
    ) {
      values.rdepLogic.totalAmount =
        Number(values.rdepLogic.rate) *
        Number(values.totalGrossLeasableArea) *
        Number(values.rdepLogic.months);
      setFieldValue(
        "rdepLogic.totalAmount",
        Number(values.rdepLogic.rate) *
        Number(values.totalGrossLeasableArea) *
        Number(values.rdepLogic.months)
      );
    }
    if(values.rdepLogic.totalAmount > 0){
      this.calculateEscalationPercentage(values, setFieldValue, (values.rdepLogic.totalAmount/values.rdepLogic.months));
    }
    

    // if (this.state.period > 1) {
    //   this.calculateMilestoneAmount(1, values, 0);
    // }
  }

  calculateEscalationPercentage(values, setFieldValue, currentRecord) {
    if ( typeof this.state.rentDepositDetails[values.rdepLogic.rentDepositNature] != "undefined" && this.state.rentDepositDetails[values.rdepLogic.rentDepositNature].length > 0) {
      let count = this.state.rentDepositDetails[values.rdepLogic.rentDepositNature].length;
      let prevMonth = parseFloat(this.state.rentDepositDetails[values.rdepLogic.rentDepositNature][count - 1]['months']);
      let prevRecord = this.state.rentDepositDetails[values.rdepLogic.rentDepositNature][count - 1]['totalAmount']/prevMonth;
      let percent = ((currentRecord-prevRecord)/prevRecord)*100;
      setFieldValue(
        "rdepLogic.escalationPercent",
        (
          percent
        ).toFixed(2)
      );
    }
  }

  changeFieldName(e, id, values) {
    console.log(values);
    if (e.target.value == "Due on Lease Commencement Date") {
      this.state.milestones[id].dueDate = this.state.leaseCommencementDate;
      values.rdepLogic.milestones[id].dueDate =
        this.state.leaseCommencementDate;
    } else {
      this.state.milestones[id].dueDate = "";
      // values.rdepLogic.milestones[id].dueDate = "";
    }
    if (e.target.value.includes("Escalation")) {
      this.state.milestones[id].milestoneQuantityType = "RDEP Milestone %";
    } else {
      this.state.milestones[id].milestoneQuantityType =
        "RDEP Milestone # Months";
    }
  }

  changeMilestonePercentName(e, id, values) {
    console.log(e.target.value);
    if (e.target.value == "RDEP Months") {
      this.state.milestones[id].milestoneQuantityType =
        "RDEP Milestone # Months";
    } else if (e.target.value == "RDEP Percent") {
      this.state.milestones[id].milestoneQuantityType = "RDEP Milestone %";
    } else {
      this.state.milestones[id].milestoneQuantityType = "";
    }

    if (e.target.value == "RDEP Months") {
      this.state.milestones[id].amount =
        (values.rdepLogic.totalAmount / values.rdepLogic.months) *
        Number(this.state.milestones[id].milestonePercent);
      values.rdepLogic.milestones[id].amount = this.state.milestones[id].amount;
      this.setState({});
    } else if (e.target.value == "Flat Amount") {

    } else {
      var previousAmount = 0;
      if (
        this.state.rentDepositDetails[values.rdepLogic.rentDepositNature] ===
        undefined ||
        this.state.rentDepositDetails[values.rdepLogic.rentDepositNature]
          .length == 0
      ) {
        previousAmount = 0;
      } else {
        previousAmount =
          this.state.rentDepositDetails[values.rdepLogic.rentDepositNature][
            this.state.rentDepositDetails[values.rdepLogic.rentDepositNature]
              .length - 1
          ].totalAmount;
      }

      var currentAmount = values.rdepLogic.totalAmount;

      var balanceAmount = currentAmount - previousAmount;
      this.state.milestones[id].amount =
        (balanceAmount / 100) * this.state.milestones[id].milestonePercent;

      values.rdepLogic.milestones[id].amount = this.state.milestones[id].amount;

      this.setState({});
    }
  }

  calculateMilestoneAmount(e, values, id) {
    console.log("1");
    if (this.state.period == "1") {
      if (values.rdepLogic.milestones[id].milestoneType == "RDEP Months") {
        this.state.milestones[id].amount =
          (values.rdepLogic.totalAmount / values.rdepLogic.months) *
          Number(this.state.milestones[id].milestonePercent);
        values.rdepLogic.milestones[id].amount =
          this.state.milestones[id].amount;
      } else {
        this.state.milestones[id].amount =
          (values.rdepLogic.totalAmount *
            Number(this.state.milestones[id].milestonePercent)) /
          100;
        // Number(this.state.milestones[id].milestonePercent);
        values.rdepLogic.milestones[id].amount =
          this.state.milestones[id].amount;
      }
      this.setState({});
    } else {
      console.log("2");
      var previousAmount =
        this.state.rentDepositDetails[values.rdepLogic.rentDepositNature][
          this.state.rentDepositDetails[values.rdepLogic.rentDepositNature]
            .length - 1
        ].totalAmount;
      var currentAmount = values.rdepLogic.totalAmount;
      var balanceAmount = currentAmount - previousAmount;

      this.state.milestones[id].amount = (balanceAmount / 100) * 100;
      values.rdepLogic.milestones[id].amount = this.state.milestones[id].amount;
      this.setState({});
    }
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _rdd = this.state.rentDepositDetails;
    _rdd[this.state.keyvalue].splice(this.state.index_val, 1);
    this.setState({
      rentDepositDetails: _rdd,
      showForm: true,
    });
    this.state.period--;
    this.state.period--;
    this.setState({
      delete: false,
      index_val: "",
      keyvalue: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  biFurcateLandlord(e, values) {
    if (this.state.biFurcateLandlordCheckbox === true) {
      this.setState({ biFurcateLandlordCheckbox: false });
    } else {
      this.setState({ biFurcateLandlordCheckbox: true });
    }
  }

  calculateRentRate(e, values, setFieldValue) {
    if (e.target.value > 0 && typeof this.state.rentDepositDetails[values.rdepLogic.rentDepositNature] != "undefined" && this.state.rentDepositDetails[values.rdepLogic.rentDepositNature].length > 0) {
      let count = this.state.rentDepositDetails[values.rdepLogic.rentDepositNature].length;
      let prevMonth = parseFloat(this.state.rentDepositDetails[values.rdepLogic.rentDepositNature][count - 1]['months']);
      let prevRecord = this.state.rentDepositDetails[values.rdepLogic.rentDepositNature][count - 1]['totalAmount']/prevMonth;

      let reviseTotalAmt = Number(prevRecord) + Number((prevRecord * e.target.value) / 100);
      let currentMonths = parseFloat(values.rdepLogic.months);
      let newRate = 0;
      if (values.rdepLogic.rateUOM == "Per Sq Ft" && values.rdepLogic.onArea == "Gross Leasable Area") {
        newRate = (reviseTotalAmt / values.totalGrossLeasableArea)
      } else if (values.rdepLogic.rateUOM == "Per Sq Ft" && values.rdepLogic.onArea == "Usable Area") {
        newRate = (reviseTotalAmt / values.totalUsableArea)
      } else if (values.rdepLogic.rateUOM == "Per Sq Ft" && values.rdepLogic.onArea == "Carpet Area") {
        newRate = (reviseTotalAmt / values.totalCarpetArea)
      } else {
        let rateVal = reviseTotalAmt - (reviseTotalAmt - prevRecord)
        newRate = rateVal + ((rateVal * e.target.value / 100))
      }

      setFieldValue(
        "rdepLogic.rate",
        (
          newRate
        ).toFixed(2)
      );

      setFieldValue(
        "rdepLogic.totalAmount",
        (
          reviseTotalAmt * currentMonths
        ).toFixed(2)
      );
    }
  }

  milestoneTabs(handleChange, values) {
    var heads = [];
    for (var i = 0; i < this.state.milestonesCount; i++) {
      heads.push(<Tab>RDEP Milestone {i + 1}</Tab>);
    }

    var body = [];

    for (var i = 0; i < this.state.milestonesCount; i++) {
      if (
        this.state.milestones[i] === undefined ||
        this.state.milestones[i] === null
      ) {
        this.state.milestones[i] = {};
        this.state.milestones[i].milestoneName = "";
        this.state.milestones[i].dueDate = "";
        this.state.milestones[i].milestonePercent =
          this.state.period == 1 ? "" : 100;
        this.state.milestones[i].amount = "";
        this.state.milestones[i].milestoneQuantityType =
          "RDEP Milestone # Months";
        this.state.milestones[i].milestoneType = "";
        values.rdepLogic.milestones[i] = {};
        values.rdepLogic.milestones[i].milestoneName = "";
        values.rdepLogic.milestones[i].dueDate = "";
        values.rdepLogic.milestones[i].milestonePercent =
          this.state.period == 1 ? "" : 100;
        values.rdepLogic.milestones[i].amount = "";
        values.rdepLogic.milestones[i].milestoneType = "";
      }
      body.push(
        <TabPanel>
          <div className="newGridSectionForFormMain">
            <div className="newGridSectionInner">
              <label>
                Milestone Name <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <select
                  param={i}
                  value={this.state.milestones[i].milestoneName}
                  name={"rdepLogic.milestones[" + i + "].milestoneName"}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].milestoneName = e.target.value;
                    this.changeFieldName(e, id, values);
                    handleChange(e);
                  }}
                >
                  <option value="" label="Select" defaultValue />
                  {this.state.milestoneNamesValues.map((item, i) => (
                    <option key={"milestoneNamesValues" + item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {this.validator.message(
                  "Milestone Name",
                  this.state.milestones[i].milestoneName,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>
            <div className="newGridSectionInner">
              <label>
                Due Date <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <Field
                  type="date"
                  param={i}
                  value={this.state.milestones[i].dueDate}
                  name={"rdepLogic.milestones[" + i + "].dueDate"}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].dueDate = e.target.value;
                    handleChange(e);
                  }}
                />
                {this.validator.message(
                  "Due Date",
                  this.state.milestones[i].dueDate,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>
            {this.state.period == "1" && (
              <div className="newGridSectionInner">
                <label>
                  Milestone Type <span className="astrik">*</span>
                </label>
                <div className="position-relative">
                  <select
                    param={i}
                    value={this.state.milestones[i].milestoneType}
                    name={"rdepLogic.milestones[" + i + "].milestoneType"}
                    onChange={(e) => {
                      var id = e.target.getAttribute("param");
                      this.state.milestones[id].milestoneType = e.target.value;
                      this.changeMilestonePercentName(e, id, values);
                      handleChange(e);
                    }}
                  >
                    <option value="" label="Select" defaultValue />
                    <option value="RDEP Months" label="RDEP Months" />
                    <option value="RDEP Percent" label="RDEP Percent" />
                    <option value="Flat Amount" label="Flat Amount" />
                  </select>
                  {this.validator.message(
                    "Milestone Type",
                    this.state.milestones[i].milestoneType,
                    "required",
                    { className: "text-danger" }
                  )}
                </div>
              </div>
            )}
            {this.state.milestones[i].milestoneQuantityType != '' && (
              <div className="newGridSectionInner">
                <label>
                  {this.state.milestones[i].milestoneQuantityType}
                </label>
                <div className="position-relative">
                  <Field
                    type="text"
                    param={i}
                    value={
                      this.state.period === 1
                        ? this.state.milestones[i].milestonePercent
                        : 100
                    }
                    readOnly={this.state.period === 1 ? false : true}
                    name={"rdepLogic.milestones[" + i + "].milestonePercent"}
                    onChange={(e) => {
                      var id = e.target.getAttribute("param");
                      this.state.milestones[id].milestonePercent = e.target.value;
                      handleChange(e);
                    }}
                    onBlur={(e) => {
                      var id = e.target.getAttribute("param");
                      this.calculateMilestoneAmount(e, values, id);
                    }}
                  />
                  {/* Commented validation message */}
                </div>
              </div>
            )}
            <div className="newGridSectionInner">
              <label>
                RDEP Milestone Amount (Rs.) <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <Field
                  type="text"
                  name={"rdepLogic.milestones[" + i + "].amount"}
                  param={i}
                  value={this.state.milestones[i].amount}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].amount = e.target.value;
                    handleChange(e);
                  }}
                />
                {this.validator.message(
                  "RDEP Milestone Amount",
                  this.state.milestones[i].amount,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>
          </div>
        </TabPanel>
      );
    }

    return (
      <div>
        <Tabs>
          <TabList>{heads}</TabList>
          <div>{body}</div>
        </Tabs>
      </div>
    );
  }

  landlordPercentage(handleChange, values) {
    var body = [];
    for (var i = 0; i < this.state.landlordList.length; i++) {
      body.push(
        <div className="newGridSectionInner" key={i}>
          <label>
            {this.state.landlordList[i].company_name}
          </label>
          <div className="position-relative">
            <Field
              param={i}
              type="text"
              name={this.state.landlordList[i].percent}
              value={this.state.landlordList[i].percent}
              onChange={(e) => {
                var id = e.target.getAttribute("param");
                this.state.landlordList[id].percent = e.target.value;
                this.setState({});
                handleChange(e);
              }}
            />
          </div>
        </div>
      );
    }
    return body;
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={"/createlease/cam-deposit-details/" + this.props.match.params.id}
        />
      );
    }
    return (
      <div className="parentContainer createLease">
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Security Deposit Details</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Rent Deposit Details</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                console.log(this.state.landlordList);
                let count = 0;
                for (var key in this.state.rentDepositDetails) {
                  count = 1;
                  break;
                }
                if (count == 0) {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }
                var rentDepositDetails = { ...this.state.rentDepositDetails };
                values.rentDepositDetails = rentDepositDetails;
                values.biFurcateLandlordCheckbox =
                  this.state.biFurcateLandlordCheckbox;
                // values.landlordList = this.state.landlordList;
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-rent-deposit-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" className="customTabs">
                      <div className="newGridSectionParent">
                        {this.state.showForm && (
                          <div className="d-flex gap-5">
                            <label>
                              <Field
                                style={{ width: 'min-content', marginRight: '10px' }}
                                type="checkbox"
                                name="bifurcateCheckBox"
                                value="bifurcateCheckBox"
                                className="sameAs"
                                checked={this.state.biFurcateLandlordCheckbox}
                                onClick={(e) => {
                                  this.biFurcateLandlord(e, values);
                                }}
                              />
                              BiFurcate By Landlord
                            </label>
                          </div>
                        )}
                        <div class="gridColOneByThree textWithHrTag"><hr class="m-0 my-4" /></div>
                        <div className="newGridSectionForFormMain">
                          {this.state.showForm && (
                            <>
                              <div className="newGridSectionInner">
                                <label>
                                  Lease Term (YY-MM-DD) <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermYY}
                                      />

                                    </div>
                                    <div className="col-sm-4">
                                      <Field
                                        type="text"
                                        name="leaseTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermMM}
                                      />

                                    </div>
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermDD}
                                      />

                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="leaseTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermYY}
                                      />

                                    </div>
                                    <div className="col-sm-4">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermMM}
                                      />

                                    </div>
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermDD}
                                      />

                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="leaseRenewalTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>From</label>
                                <div className="position-relative">
                                  <Field type="date" name="from" />
                                  <ErrorMessage
                                    name="from"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>To</label>
                                <div className="position-relative">
                                  <Field type="date" name="to" />
                                  <ErrorMessage
                                    name="to"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              {this.state.biFurcateLandlordCheckbox === true && (
                                <>
                                  {this.landlordPercentage(handleChange, values)}
                                </>
                              )}

                              <div className="newGridSectionInner">
                                <label>
                                  Rent Deposit Nature (RDEP)
                                  <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    disabled={this.state.disableOnEdit}
                                    name={"rdepLogic.rentDepositNature"}
                                    onChange={(e) => {
                                      if (
                                        this.getDepositNature(
                                          e,
                                          values,
                                          setFieldValue
                                        )
                                      ) {
                                        handleChange(e);
                                      }
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Refundable - Interest Free"
                                      label="Refundable - Interest Free"
                                    />
                                    <option
                                      value="Refundable - Interest Bearing"
                                      label="Refundable - Interest Bearing"
                                    />
                                    <option
                                      value="Non Refundable - Interest Free"
                                      label="Non Refundable - Interest Free"
                                    />
                                    <option
                                      value="Non Refundable - Interest Bearing"
                                      label="Non Refundable - Interest Bearing"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "Rent Deposit Nature",
                                    values.rdepLogic.rentDepositNature,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>

                              {values.rdepLogic.rentDepositNature !== "" && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>Period</label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="rdepLogic.period"
                                        disabled={this.state.disableOnEdit}
                                        value={this.state.period}
                                        onChange={(e) => {
                                          this.state.period = e.target.value;
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Period Term</label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-4 p-0">
                                          <Field
                                            type="text"
                                            name="periodTermmYY"
                                            placeholder="YY"
                                            className="centerPlaceHolder"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermYY}
                                            onChange={(e) => {
                                              this.state.periodTermYY = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />

                                        </div>
                                        <div className="col-sm-4">
                                          <Field
                                            type="text"
                                            name="periodTermMM"
                                            placeholder="MM"
                                            className="centerPlaceHolder"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermMM}
                                            onChange={(e) => {
                                              this.state.periodTermMM = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />

                                        </div>
                                        <div className="col-sm-4 p-0">
                                          <Field
                                            type="text"
                                            name="periodTermDD"
                                            placeholder="DD"
                                            className="centerPlaceHolder"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermDD}
                                            onChange={(e) => {
                                              this.state.periodTermDD = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />

                                        </div>
                                      </div>
                                      <ErrorMessage
                                        name="mfLogic.periodTerm"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner"></div>

                                  <div className="newGridSectionInner">
                                    <label>From <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        readOnly={this.state.readOnEdit}
                                        name="rdepLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>To <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        readOnly={this.state.readOnEdit}
                                        name="rdepLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>RDEP # Months</label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="rdepLogic.months"
                                      />
                                      <ErrorMessage
                                        name="rdepLogic.months"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>RDEP Rate UOM <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="rdepLogic.rateUOM"
                                        onChange={(e) => {
                                          this.validator = new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                          values.rdepLogic.rateUOM = e.target.value;
                                          handleChange(e);
                                          this.calculateRdepAmount(values, setFieldValue);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Flat Amount" label="Flat Amount" />
                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                      </Field>
                                      {this.validator.message(
                                        "RDEP Rate UOM",
                                        values.rdepLogic.rateUOM,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {values.rdepLogic.rateUOM === "Per Sq Ft" && (
                                    <div className="newGridSectionInner">
                                      <label>RDEP On Area</label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="rdepLogic.onArea"
                                          onChange={(e) => {
                                            handleChange(e);
                                            values.rdepLogic.onArea = e.target.value;
                                            this.calculateRdepAmount(values, setFieldValue);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Usable Area" label="Usable Area" />
                                          <option value="Carpet Area" label="Carpet Area" />
                                          <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                        </Field>
                                        {this.validator.message(
                                          "On Area",
                                          values.rdepLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  {typeof this.state.rentDepositDetails[values.rdepLogic.rentDepositNature] !== "undefined" &&
                                    this.state.rentDepositDetails[values.rdepLogic.rentDepositNature].length > 0 && (
                                      <div className="newGridSectionInner">
                                        <label>Escalation %</label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="rdepLogic.escalationPercent"
                                            onBlur={(e) => {
                                              this.calculateRentRate(e, values, setFieldValue);
                                            }}
                                          />
                                          {this.validator.message(
                                            "Escalation %",
                                            values.rdepLogic.escalationPercent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                  <div className="newGridSectionInner">
                                    <label>RDEP # Rate</label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="rdepLogic.rate"
                                        onBlur={(e) => {
                                          this.calculateRdepAmount(values, setFieldValue);
                                          
                                          if (this.state.period > 1) {
                                            this.calculateMilestoneAmount(e, values, 0);
                                            //this.calculateEscalationPercentage(e, values, setFieldValue);
                                          }
                                        }}
                                      />
                                      {this.validator.message(
                                        "RDEP Rate",
                                        values.rdepLogic.rate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>RDEP Total Amount</label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="rdepLogic.totalAmount"
                                      />
                                      <ErrorMessage
                                        name="rdepLogic.totalAmount"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>RDEP Milestones Count</label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="rdepLogic.milestonesCount"
                                        value={this.state.period === 1 ? this.state.milestonesCount : 1}
                                        readOnly={this.state.period !== 1}
                                        onChange={(e) => {
                                          if (!isNaN(e.target.value)) {
                                            this.setState({
                                              milestonesCount: e.target.value,
                                            });
                                          }
                                        }}
                                      />
                                      <ErrorMessage
                                        name="rdepLogic.milestonesCount"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                          {values.rdepLogic.rentDepositNature !== "" && (
                            <div className="gridColOneByThree depositNature">
                              {this.state.showForm && (
                                <div className="unitFormContainerNew rentButtons">
                                  {this.milestoneTabs(handleChange, values)}
                                  <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                    <button
                                      className="add_button"
                                      type="button"
                                      onClick={(e) => {
                                        this.addDetails(values, resetForm);
                                      }}
                                    >
                                      Add
                                    </button>
                                    <button
                                      className="reset_button"
                                      type="reset"
                                      onClick={(e) => {
                                        this.resetDetails(values, resetForm);
                                      }}
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes mb-3" name="notes_11" />
                          </div>
                        </div>
                        {this.mainFormValidator.message(
                          "Rent Deposit Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple tableSimpleWithNoFlex">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Rent Deposit Details</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(this.state.rentDepositDetails).map(
                                function (key, index1) {
                                  return this.state.rentDepositDetails[key].map(
                                    function (name, index) {
                                      return (
                                        <tr key={"mfTable" + index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <a
                                              className="popupLink"
                                              onClick={(e) => {
                                                this.state.popupData = name;
                                                this.openModal();
                                              }}
                                            >
                                              {name.period}
                                            </a>
                                          </td>
                                          <td>
                                            {name.periodTermYY == ""
                                              ? "0"
                                              : name.periodTermYY}
                                            {"-"}
                                            {name.periodTermMM == ""
                                              ? "0"
                                              : name.periodTermMM}
                                            {"-"}
                                            {name.periodTermDD == ""
                                              ? "0"
                                              : name.periodTermDD}
                                          </td>
                                          <td>
                                            {/* {dateFormat(
                                            name.fromDate,
                                            "dd mmm yyyy"
                                          )} */}
                                            {leaseDateFormat(name.fromDate)}
                                          </td>
                                          <td>
                                            {/* {dateFormat(
                                            name.toDate,
                                            "dd mmm yyyy"
                                          )} */}
                                            {leaseDateFormat(name.toDate)}
                                          </td>
                                          <td>{name.rentDepositNature}</td>
                                          <td>{name.totalAmount || "-"}</td>
                                          <td>
                                            {/* <button
                                            type="button"
                                            className="tableActionEdit rentalEdit"
                                            onClick={(e) => {
                                              this.editRd(index, values, key);
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faPen} />
                                          </button> */}
                                            {this.state.rentDepositDetails[key]
                                              .length ==
                                              index + 1 && (
                                                <button
                                                  type="button"
                                                  className="actionDelete rentalDeleteButton"
                                                  onClick={(e) => {
                                                    // if (
                                                    //   window.confirm(
                                                    //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                                    //   )
                                                    // ) {
                                                    //   var _rdd =
                                                    //     this.state
                                                    //       .rentDepositDetails;
                                                    //   _rdd[key].splice(index, 1);
                                                    //   this.setState({
                                                    //     rentDepositDetails: _rdd,
                                                    //     showForm: true,
                                                    //   });
                                                    //   this.state.period--;
                                                    // }
                                                    this.setState({
                                                      delete: true,
                                                      index_val: index,
                                                      keyvalue: key,
                                                    });
                                                  }}
                                                >
                                                  <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                              )}
                                          </td>
                                        </tr>
                                      );
                                    },
                                    this
                                  );
                                },
                                this
                              )}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                  {/* <div className="unitFormContainerNew p-0 m-0">
                    <Form className="customTabs">
                      <div className="newGridSectionParent">
                        {this.state.showForm && (
                          <div className="unitFormContainerNew leaseSection">
                            <div className="row m-0">
                              <div className="col-lg-12 autoFillContainer text-center mb-4">
                                <label className="rentBifurcate">
                                  <Field
                                    type="checkbox"
                                    name="bifurcateCheckBox"
                                    value="bifurcateCheckBox"
                                    className="sameAs"
                                    checked={this.state.biFurcateLandlordCheckbox}
                                    onClick={(e) => {
                                      this.biFurcateLandlord(e, values);
                                    }}
                                  />
                                  BiFurcate By Landlord
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Lease Term (YY-MM-DD){" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-3 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermYY}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermMM}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermDD}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="leaseTerm"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Lease Renewal Term (YY-MM-DD){" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-3 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermYY}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermMM}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermDD}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="leaseRenewalTerm"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row m-0">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      From
                                    </label>
                                    <div className="col-sm-7">
                                      <Field type="date" name="from" />
                                      <ErrorMessage
                                        name="from"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      To
                                    </label>
                                    <div className="col-sm-7">
                                      <Field type="date" name="to" />
                                      <ErrorMessage
                                        name="to"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.state.biFurcateLandlordCheckbox === true && (
                              <div className="row m-0">
                                {this.landlordPercentage(handleChange, values)}
                              </div>
                            )}
                            <div className="row m-0">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Rent Deposit Nature (RDEP)
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        disabled={this.state.disableOnEdit}
                                        name={"rdepLogic.rentDepositNature"}
                                        onChange={(e) => {
                                          if (
                                            this.getDepositNature(
                                              e,
                                              values,
                                              setFieldValue
                                            )
                                          ) {
                                            handleChange(e);
                                          }
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="Refundable - Interest Free"
                                          label="Refundable - Interest Free"
                                        />
                                        <option
                                          value="Refundable - Interest Bearing"
                                          label="Refundable - Interest Bearing"
                                        />
                                        <option
                                          value="Non Refundable - Interest Free"
                                          label="Non Refundable - Interest Free"
                                        />
                                        <option
                                          value="Non Refundable - Interest Bearing"
                                          label="Non Refundable - Interest Bearing"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "Rent Deposit Nature",
                                        values.rdepLogic.rentDepositNature,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {values.rdepLogic.rentDepositNature !== "" && (
                              <div className="depositNature">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="text"
                                            name="rdepLogic.period"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.period}
                                            onChange={(e) => {
                                              this.state.period = e.target.value;
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term
                                        </label>
                                        <div className="col-sm-3 leaseTermFieldWidth">
                                          <Field
                                            type="text"
                                            name="periodTermmYY"
                                            placeholder="YY"
                                            className="centerPlaceHolder"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermYY}
                                            onChange={(e) => {
                                              this.state.periodTermYY =
                                                e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />
                                        </div>
                                        <div className="col-sm-2 leaseTermFieldWidth">
                                          <Field
                                            type="text"
                                            name="periodTermMM"
                                            placeholder="MM"
                                            className="centerPlaceHolder"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermMM}
                                            onChange={(e) => {
                                              this.state.periodTermMM =
                                                e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />
                                        </div>
                                        <div className="col-sm-2 leaseTermFieldWidth">
                                          <Field
                                            type="text"
                                            name="periodTermDD"
                                            placeholder="DD"
                                            className="centerPlaceHolder"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermDD}
                                            onChange={(e) => {
                                              this.state.periodTermDD =
                                                e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />
                                        </div>
                                        <ErrorMessage
                                          name="mfLogic.periodTerm"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            readOnly={this.state.readOnEdit}
                                            name="rdepLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            readOnly={this.state.readOnEdit}
                                            name="rdepLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          RDEP # Months
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="text"
                                            name="rdepLogic.months"
                                          />
                                          <ErrorMessage
                                            name="rdepLogic.months"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          RDEP Rate UOM
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"rdepLogic.rateUOM"}
                                            onChange={(e) => {
                                              this.validator =
                                                new SimpleReactValidator({
                                                  autoForceUpdate: this,
                                                });
                                              values.rdepLogic.rateUOM =
                                                e.target.value;
                                              handleChange(e);
                                              this.calculateRdepAmount(
                                                values,
                                                setFieldValue
                                              );
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Flat Amount"
                                              label="Flat Amount"
                                            />
                                            <option
                                              value="Per Sq Ft"
                                              label="Per Sq Ft"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "RDEP Rate UOM",
                                            values.rdepLogic.rateUOM,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {values.rdepLogic.rateUOM == "Per Sq Ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            RDEP On Area
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"rdepLogic.onArea"}
                                              onChange={(e) => {
                                                handleChange(e);
                                                values.rdepLogic.onArea =
                                                  e.target.value;
                                                this.calculateRdepAmount(
                                                  values,
                                                  setFieldValue
                                                );
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Usable Area"
                                                label="Usable Area"
                                              />
                                              <option
                                                value="Carpet Area"
                                                label="Carpet Area"
                                              />
                                              <option
                                                value="Gross Leasable Area"
                                                label="Gross Leasable Area"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "On Area",
                                              values.rdepLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {
                                    typeof this.state.rentDepositDetails[values.rdepLogic.rentDepositNature] != "undefined" && this.state.rentDepositDetails[values.rdepLogic.rentDepositNature].length > 0 && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Escalation %
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="rdepLogic.escalationPercent"
                                                //disabled={this.state.disableOnEdit}
                                                onBlur={(e) => {
                                                  this.calculateRentRate(
                                                    e,
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                              />
                                              {this.validator.message(
                                                "Escalation %",
                                                values.rdepLogic.escalationPercent,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  }

                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          RDEP # Rate
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="rdepLogic.rate"
                                            onBlur={(e) => {
                                              this.calculateRdepAmount(
                                                values,
                                                setFieldValue
                                              );
                                              if (this.state.period > 1) {
                                                this.calculateMilestoneAmount(
                                                  e,
                                                  values,
                                                  0
                                                );
                                              }
                                            }}
                                          />
                                          {this.validator.message(
                                            "RDEP Rate",
                                            values.rdepLogic.rate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          RDEP Total Amount
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="text"
                                            name="rdepLogic.totalAmount"
                                          />
                                          <ErrorMessage
                                            name="rdepLogic.totalAmount"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          RDEP Milestones Count
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="text"
                                            name="rdepLogic.milestonesCount"
                                            value={
                                              this.state.period === 1
                                                ? this.state.milestonesCount
                                                : 1
                                            }
                                            readOnly={
                                              this.state.period === 1 ? false : true
                                            }
                                            onChange={(e) => {
                                              if (!isNaN(e.target.value)) {
                                                this.setState({
                                                  milestonesCount: e.target.value,
                                                });
                                              }
                                            }}
                                          />
                                          <ErrorMessage
                                            name="rdepLogic.milestonesCount"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {values.rdepLogic.rentDepositNature !== "" && (
                          <div className="depositNature">
                            {this.state.showForm && (
                              <div className="unitFormContainerNew rentButtons">
                                {this.milestoneTabs(handleChange, values)}
                                <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                  <button
                                    className="add_button"
                                    type="button"
                                    onClick={(e) => {
                                      this.addDetails(values, resetForm);
                                    }}
                                  >
                                    Add
                                  </button>
                                  <button
                                    className="reset_button"
                                    type="reset"
                                    onClick={(e) => {
                                      this.resetDetails(values, resetForm);
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        <div className="unitFormContainerNew">
                          <span className="remarks">Notes/Remarks</span>
                          <Field as="textarea" className="notes mb-3" name="notes_11" />
                        </div>

                        {this.mainFormValidator.message(
                          "Rent Deposit Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple tableSimpleWithNoFlex">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Rent Deposit Details</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(this.state.rentDepositDetails).map(
                                function (key, index1) {
                                  return this.state.rentDepositDetails[key].map(
                                    function (name, index) {
                                      return (
                                        <tr key={"mfTable" + index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <a
                                              className="popupLink"
                                              onClick={(e) => {
                                                this.state.popupData = name;
                                                this.openModal();
                                              }}
                                            >
                                              {name.period}
                                            </a>
                                          </td>
                                          <td>
                                            {name.periodTermYY == ""
                                              ? "0"
                                              : name.periodTermYY}
                                            {"-"}
                                            {name.periodTermMM == ""
                                              ? "0"
                                              : name.periodTermMM}
                                            {"-"}
                                            {name.periodTermDD == ""
                                              ? "0"
                                              : name.periodTermDD}
                                          </td>
                                          <td>
                                            {leaseDateFormat(name.fromDate)}
                                          </td>
                                          <td>
                                            {leaseDateFormat(name.toDate)}
                                          </td>
                                          <td>{name.rentDepositNature}</td>
                                          <td>{name.totalAmount || "-"}</td>
                                          <td>
                                            {this.state.rentDepositDetails[key]
                                              .length ==
                                              index + 1 && (
                                                <button
                                                  type="button"
                                                  className="actionDelete rentalDeleteButton"
                                                  onClick={(e) => {
                                                    // if (
                                                    //   window.confirm(
                                                    //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                                    //   )
                                                    // ) {
                                                    //   var _rdd =
                                                    //     this.state
                                                    //       .rentDepositDetails;
                                                    //   _rdd[key].splice(index, 1);
                                                    //   this.setState({
                                                    //     rentDepositDetails: _rdd,
                                                    //     showForm: true,
                                                    //   });
                                                    //   this.state.period--;
                                                    // }
                                                    this.setState({
                                                      delete: true,
                                                      index_val: index,
                                                      keyvalue: key,
                                                    });
                                                  }}
                                                >
                                                  <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                              )}
                                          </td>
                                        </tr>
                                      );
                                    },
                                    this
                                  );
                                },
                                this
                              )}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>

                  </div> */}
                </>
              )}
            </Formik>
          </div >
        </div >
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row m-0">
                        <div className="col-lg-12">
                          <ul>
                            <li>Rent Deposit Details</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen &&
                    this.rentDepositDetailPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div >
    );
  }
  rentDepositDetailPopup(rent) {
    return this.rentalDetailsPopup(rent);
  }
  rentalDetailsPopup(rent) {
    console.log(rent);
    return (
      <div className="container">
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{rent.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rent.periodTermYY == "" ? "0" : rent.periodTermYY}
                  {"-"}
                  {rent.periodTermMM == "" ? "0" : rent.periodTermMM}
                  {"-"}
                  {rent.periodTermDD == "" ? "0" : rent.periodTermDD}
                </label>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Deposit Nature (RDEP) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rent.rentDepositNature}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {/* {dateFormat(rent.fromDate, "dd mmm yyyy")} */}
                  {leaseDateFormat(rent.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {/* {dateFormat(rent.toDate, "dd mmm yyyy")} */}
                  {leaseDateFormat(rent.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  RDEP # Months <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{rent.months}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  RDEP Rate UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rent.rateUOM}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  RDEP # Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{rent.rate}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  RDEP On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{rent.onArea}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  RDEP Total Amount <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rent.totalAmount}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  RDEP MileStones
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">Milestone Name</th>
                          <th scope="col">Due Date</th>
                          <th scope="col">RDEP Milestone</th>
                          <th scope="col">RDEP Milestone Amount (Rs.)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rent.milestones.length > 0 &&
                          rent.milestones.map((name, index) => (
                            <tr key={index}>
                              <td>{name.milestoneName}</td>
                              <td>
                                {/* {dateFormat(name.dueDate, "dd mmm yyyy")}{" "} */}
                                {leaseDateFormat(name.dueDate)}
                              </td>
                              <td>
                                {name.milestonePercent}
                                {name.milestoneType == "RDEP Months"
                                  ? " Months"
                                  : " %"}
                              </td>
                              <td>{name.amount}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(RentDepositDetails);
